export function EditIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' {...props}>
      <g id='Icon_feather-edit-3' data-name='Icon feather-edit-3' transform='translate(-3 -2.818)'>
        <path
          id='Union_2'
          data-name='Union 2'
          d='M7,14a.733.733,0,0,1,0-1.465h6.3A.733.733,0,0,1,13.3,14ZM.205,13.786a.755.755,0,0,1-.184-.7l.7-2.929a.74.74,0,0,1,.184-.34L9.655.669a2.117,2.117,0,0,1,3.09,0,2.363,2.363,0,0,1,0,3.232L4,13.053a.692.692,0,0,1-.326.192l-2.8.732A.672.672,0,0,1,.7,14,.684.684,0,0,1,.205,13.786ZM10.645,1.7,2.032,10.714l-.37,1.548,1.48-.387,8.613-9.009a.849.849,0,0,0,0-1.161.76.76,0,0,0-1.11,0Z'
          transform='translate(3 2.818)'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
